import { useParams } from 'react-router-dom';

import { useGetProgressQuery } from '@/services/course';

interface ICourseProgress {
  lessons: number;
  watchedLessons: number;
  progress: number;
}

export const useCourseProgress = (): ICourseProgress => {
  const { hash } = useParams();
  const { data } = useGetProgressQuery(hash);

  const courseInfo = (data ?? []).reduce(
    (pv, cv) => {
      pv.lessons += cv.lessons.length;
      pv.watchedLessons += cv.lessons.reduce((pv, cv) => {
        return pv + +cv.watched;
      }, 0);
      return pv;
    },
    { lessons: 0, watchedLessons: 0 }
  );

  return {
    lessons: courseInfo.lessons,
    watchedLessons: courseInfo.watchedLessons,
    progress: Math.floor((courseInfo.watchedLessons / courseInfo.lessons) * 100)
  };
};

export const useModuleProgress = (id: number): number => {
  const { hash } = useParams();
  const { data } = useGetProgressQuery(hash);

  const lessons = (data ?? []).find(module => module.id === id)?.lessons;

  const moduleInfo = (lessons ?? []).reduce((pv, cv) => {
    return pv + +cv.watched;
  }, 0);

  return (moduleInfo / lessons?.length) * 100;
};
